// src/components/PortalAuthSync.jsx
import { useEffect } from "react";
import { useOrganization, useSession, useClerk } from "@clerk/clerk-react";
import { setPortalTokenProvider, setPortalTenantSlugProvider, setPortalSignOutCallback } from "../api";

export default function PortalAuthSync() {
  const { organization } = useOrganization();
  const { session } = useSession();
  const clerk = useClerk(); // ✅ NEW: Get Clerk instance for signOut

  useEffect(() => {
    // Provide portal token (Clerk template: "portal")
    setPortalTokenProvider(async () => {
      if (!session) return null;
      const tok = await session.getToken({ template: "portal" });
      return tok || null;
    });

    // Provide current org slug to the API (or null if none)
    const slug = organization?.slug || null;
    setPortalTenantSlugProvider(() => slug);

    // ✅ NEW: Provide sign-out callback for when session expires
    setPortalSignOutCallback(async () => {
      try {
        console.log("[PortalAuthSync] Signing out of Clerk due to session expiry");
        await clerk.signOut();
        console.log("[PortalAuthSync] Clerk sign-out complete");
      } catch (err) {
        console.error("[PortalAuthSync] Sign-out failed:", err);
        // Don't throw - we still want to redirect to login
      }
    });

    // Cleanup on unmount/sign-out
    return () => {
      setPortalTokenProvider(null);
      setPortalTenantSlugProvider(null);
      setPortalSignOutCallback(null); // ✅ NEW: Clean up callback
    };
  }, [organization?.slug, session, clerk]); // ✅ NEW: Added clerk to dependencies

  return null;
}
